import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { articlesData } from '../../mocks/articles';
import SEO from '../../components/base/SEO';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Psikolog Esra Erten | Çocuk ve Ergen Psikoloğu | İstanbul"
        description="İstanbul'da çocuk ve ergen psikoloğu Esra Erten. Oyun terapisi, ergen danışmanlığı, ebeveyn danışmanlığı ve aile terapisi hizmetleri. Deneyimsel oyun terapisi uzmanı. Çocukların duygusal gelişimine profesyonel destek."
        keywords="çocuk psikoloğu, ergen psikoloğu, İstanbul psikolog, oyun terapisi, ergen danışmanlığı, ebeveyn danışmanlığı, çocuk terapisi, deneyimsel oyun terapisi, aile terapisi"
        canonical="https://psikologesraerten.com/"
        ogImage="https://static.readdy.ai/image/c5866e26fdbc96711840c633abff697c/f6f769de0ba7b512ae191b22d5158d40.jpeg"
      />
      <Navbar />

      <section className="pt-32 pb-20 px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
            <div className="lg:col-span-4 space-y-6">
              <span className="text-sm text-purple-600 font-medium">Çocuk ve Ergen Psikolojisi</span>
              <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                Çocukların Duygusal Dünyasına Güvenli Bir Eşlik
              </h1>
              <p className="text-base text-gray-600 leading-relaxed">
                Çocukların ve Ergenlerin Duygularını Anlamalarına Kendilerini Güvende İfade Etmelerine ve Gelişimsel İhtiyaçlarına Uygun Destek Bulmalarına Eşlik Ediyorum
              </p>
              <Link
                to="/iletisim"
                className="inline-flex items-center px-8 py-3.5 bg-orange-500 text-white font-medium rounded-full hover:bg-orange-600 transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-orange-500/30"
              >
                Randevu Al
                <i className="ri-arrow-right-up-line ml-2 text-lg"></i>
              </Link>
            </div>

            <div className="lg:col-span-4">
              <div className="rounded-3xl overflow-hidden shadow-2xl h-[600px]">
                <img
                  src="https://public.readdy.ai/ai/img_res/af4e3b8ce33c95fd44ad65fce4e35468.jpg"
                  alt="Çocuk Terapi Odası"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            <div className="lg:col-span-4 space-y-6">
              <div className="flex items-center justify-between">
                <h3 className="text-xl font-semibold text-gray-900">Uzmanlık Alanları</h3>
                <i className="ri-arrow-right-up-line text-xl text-gray-400"></i>
              </div>

              <div className="space-y-4">
                <Link to="/oyun-terapisi" className="block rounded-3xl overflow-hidden shadow-lg h-48 relative group cursor-pointer">
                  <img
                    src="https://readdy.ai/api/search-image?query=young%20child%20drawing%20and%20expressing%20emotions%20through%20art%20therapy%20colorful%20drawings%20crayons%20in%20bright%20cheerful%20room%20child%20psychology%20creative%20expression%20emotional%20development%20simple%20clean%20background%20warm%20natural%20lighting&width=800&height=400&seq=childservice1&orientation=landscape"
                    alt="Oyun Terapisi"
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute bottom-4 left-4">
                    <span className="inline-block px-4 py-2 bg-white rounded-full text-sm font-medium text-gray-900 shadow-lg">
                      Oyun Terapisi
                    </span>
                  </div>
                </Link>

                <div className="grid grid-cols-2 gap-4">
                  <Link to="/ergen-danismanligi" className="rounded-3xl overflow-hidden shadow-lg h-48 relative group cursor-pointer">
                    <img
                      src="https://readdy.ai/api/search-image?query=teenager%20student%20studying%20with%20confidence%20in%20bright%20modern%20space%20adolescent%20psychology%20concept%20positive%20learning%20environment%20youth%20development%20simple%20clean%20background%20natural%20lighting&width=500&height=500&seq=childservice2&orientation=squarish"
                      alt="Ergen Danışmanlığı"
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                    />
                    <div className="absolute bottom-4 left-3">
                      <span className="inline-block px-3 py-1.5 bg-white rounded-full text-xs font-medium text-gray-900 shadow-lg">
                        Ergen Danışmanlığı
                      </span>
                    </div>
                  </Link>

                  <Link to="/ebeveyn-danismanligi" className="rounded-3xl overflow-hidden shadow-lg h-48 relative group cursor-pointer">
                    <img
                      src="https://readdy.ai/api/search-image?query=loving%20parent%20and%20child%20having%20warm%20conversation%20together%20in%20bright%20peaceful%20setting%20family%20counseling%20concept%20connection%20support%20parenting%20guidance%20simple%20clean%20background%20soft%20natural%20tones&width=500&height=500&seq=childservice3&orientation=squarish"
                      alt="Ebeveyn Danışmanlığı"
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                    />
                    <div className="absolute bottom-4 left-3">
                      <span className="inline-block px-3 py-1.5 bg-white rounded-full text-xs font-medium text-gray-900 shadow-lg">
                        Ebeveyn Danışmanlığı
                      </span>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-br from-orange-50 to-yellow-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Her Çocuk Özeldir, Her Hikaye Değerlidir
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-100 rounded-xl mb-6">
                <i className="ri-emotion-happy-line text-2xl text-orange-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Oyun Terapisi</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Çocuklar oyun yoluyla kendilerini en iyi ifade ederler. Oyun terapisi ile duygularını anlamalarına ve yönetmelerine yardımcı oluyoruz.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-100 rounded-xl mb-6">
                <i className="ri-parent-line text-2xl text-orange-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Ebeveyn Desteği</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Ebeveynlere çocuklarının duygusal ihtiyaçlarını anlamada ve etkili iletişim kurmada rehberlik ediyoruz.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-100 rounded-xl mb-6">
                <i className="ri-heart-pulse-line text-2xl text-orange-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Ergen Desteği</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Ergenlik döneminin güçlüklerinde gençlere güvenli bir alan sunarak, duygusal regülasyon ve sağlıklı baş etme becerilerini destekliyoruz.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="rounded-3xl overflow-hidden shadow-2xl h-[600px] cursor-pointer group" onClick={() => window.REACT_APP_NAVIGATE('/deneyimsel-oyun-terapisi')}>
              <img
                src="https://readdy.ai/api/search-image?query=professional%20child%20therapist%20conducting%20experiential%20play%20therapy%20session%20with%20young%20child%20in%20specially%20designed%20therapy%20room%20colorful%20therapeutic%20toys%20sensory%20materials%20creative%20play%20equipment%20child%20actively%20engaged%20in%20developmental%20play%20activities%20warm%20supportive%20atmosphere%20natural%20lighting%20bright%20cheerful%20environment%20promoting%20emotional%20growth%20and%20healing%20through%20structured%20play&width=900&height=1100&seq=dottherapy1&orientation=portrait"
                alt="Deneyimsel Oyun Terapisi"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
              />
            </div>

            <div>
              <span className="text-sm text-orange-600 font-semibold mb-4 block">DENEYIMSEL OYUN TERAPİSİ</span>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Deneyimsel Oyun Terapisi (DOT) Nedir?
              </h2>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Deneyimsel Oyun Terapisi, çocukların doğal iletişim dili olan oyunu kullanarak duygusal, sosyal ve bilişsel gelişimlerini destekleyen kanıta dayalı bir terapi yöntemidir.
              </p>
              <p className="text-gray-600 mb-8 leading-relaxed">
                Bu yaklaşımda çocuklar, yapılandırılmış oyun aktiviteleri aracılığıyla duygularını ifade eder, travmatik deneyimleri işler ve sağlıklı başa çıkma mekanizmaları geliştirir.
              </p>

              <div className="bg-gradient-to-br from-orange-50 to-yellow-50 rounded-2xl p-8 mb-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4">DOT Hangi Durumlarla Çalışır?</h3>
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-700">Doğum Travmaları</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-700">Gelişimsel Geçişler</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-700">Kaygı ve Korkular</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-700">Dikkat ve Davranış</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-700">Öfke ve İçe Kapanma</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-700">Akademik ve Sosyal Zorluklar</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-700">Aile Değişimleri</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-700">Depresyon Belirtileri</span>
                  </li>
                </ul>
              </div>

              <Link
                to="/deneyimsel-oyun-terapisi"
                className="inline-flex items-center px-8 py-4 bg-orange-500 text-white font-semibold rounded-full hover:bg-orange-600 transition-colors cursor-pointer whitespace-nowrap shadow-lg"
              >
                Detaylı Bilgi Al
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <span className="text-sm text-gray-500 font-light block mb-4">Uzmanlık Alanlarım</span>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Size Nasıl Yardımcı Olabilirim?
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <a href="/ebeveyn-danismanligi" className="group bg-gradient-to-br from-blue-50 to-indigo-50 rounded-3xl p-10 hover:shadow-xl transition-all cursor-pointer">
              <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform shadow-md">
                <i className="ri-parent-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Ebeveyn Danışmanlığı</h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-4">
                Anne ve babalar için ebeveynlik becerileri geliştirme, çocukla iletişim güçlendirme ve aile içi uyum.
              </p>
              <span className="text-blue-600 font-medium inline-flex items-center group-hover:gap-2 transition-all">
                Detaylı Bilgi
                <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform"></i>
              </span>
            </a>

            <a href="/ergen-danismanligi" className="group bg-gradient-to-br from-rose-50 to-pink-50 rounded-3xl p-10 hover:shadow-xl transition-all cursor-pointer">
              <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform shadow-md">
                <i className="ri-user-heart-line text-3xl text-rose-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Ergen Danışmanlığı</h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-4">
                Ergenlik döneminin zorluklarında gençlere güvenli bir alan sunarak, duygusal regülasyon ve sağlıklı baş etme becerilerini destekliyoruz. Polyvagal Teori, Çözüm Odaklı Terapi ve Sanat Terapisi teknikleriyle çalışıyoruz.
              </p>
              <span className="text-rose-600 font-medium inline-flex items-center group-hover:gap-2 transition-all">
                Detaylı Bilgi
                <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform"></i>
              </span>
            </a>

            <a href="/cocuk-danismanligi" className="group bg-gradient-to-br from-amber-50 to-orange-50 rounded-3xl p-10 hover:shadow-xl transition-all cursor-pointer">
              <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform shadow-md">
                <i className="ri-bear-smile-line text-3xl text-amber-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Çocuk Danışmanlığı</h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-4">
                Oyun terapisi ve yaşa uygun tekniklerle çocukların duygusal gelişimine destek. Davranış sorunları, kaygı ve sosyal beceriler üzerine çalışıyoruz.
              </p>
              <span className="text-amber-600 font-medium inline-flex items-center group-hover:gap-2 transition-all">
                Detaylı Bilgi
                <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform"></i>
              </span>
            </a>
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <span className="text-sm text-orange-600 font-semibold mb-4 block">NEDEN ÇOCUK PSİKOLOJİSİ?</span>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Çocukluk Yılları Gelişimin Temelidir
              </h2>
              <p className="text-gray-600 mb-8 leading-relaxed">
                Çocukluk ve ergenlik döneminde alınan destek, yaşam boyu sürecek sağlıklı duygusal gelişimin temelini atar. Çocuğunuzun duygusal ihtiyaçlarını anlamak ve ona uygun desteği sağlamak, geleceğine yapacağınız en değerli yatırımdır.
              </p>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700">Kaygı, korku ve davranış sorunları</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700">Okul uyum problemleri ve akademik zorluklar</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700">Sosyal beceri gelişimi ve arkadaşlık ilişkileri</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700">Ergenlik dönemi kimlik gelişimi ve özgüven</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700">Aile içi iletişim ve ebeveynlik becerileri</span>
                </li>
              </ul>
            </div>

            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=child%20psychologist%20working%20with%20young%20child%20in%20colorful%20therapy%20room%20warm%20supportive%20atmosphere%20professional%20counselor%20and%20child%20playing%20together%20with%20educational%20toys%20bright%20natural%20lighting%20through%20windows%20creating%20safe%20nurturing%20environment%20hope%20and%20growth%20concept%20cheerful%20pastel%20tones&width=900&height=700&seq=childwhy1&orientation=landscape"
                alt="Çocuk Terapi Seansı"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-br from-purple-50 to-pink-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Hangi Durumlarda Destek Alınmalı?
            </h2>
            <p className="text-lg text-gray-600">
              
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-10 h-10 flex items-center justify-center bg-purple-100 rounded-lg mb-4">
                <i className="ri-emotion-sad-line text-xl text-purple-600"></i>
              </div>
              <h4 className="text-base font-bold text-gray-900 mb-2">Duygusal Değişimler</h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                Aşırı üzüntü, öfke patlamaları veya ani ruh hali değişimleri
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-10 h-10 flex items-center justify-center bg-purple-100 rounded-lg mb-4">
                <i className="ri-book-open-line text-xl text-purple-600"></i>
              </div>
              <h4 className="text-base font-bold text-gray-900 mb-2">Okul Sorunları</h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                Akademik başarıda düşüş, okula gitmek istememe, dikkat problemleri
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-10 h-10 flex items-center justify-center bg-purple-100 rounded-lg mb-4">
                <i className="ri-group-line text-xl text-purple-600"></i>
              </div>
              <h4 className="text-base font-bold text-gray-900 mb-2">Sosyal Zorluklar</h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                Arkadaş edinememe, sosyal ortamlardan kaçınma, zorbalığa maruz kalma
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-10 h-10 flex items-center justify-center bg-purple-100 rounded-lg mb-4">
                <i className="ri-alarm-warning-line text-xl text-purple-600"></i>
              </div>
              <h4 className="text-base font-bold text-gray-900 mb-2">Davranış Değişiklikleri</h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                Uyku ve yeme düzeninde değişiklik, geri çekilme, saldırgan davranışlar
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <span className="text-sm text-orange-600 font-semibold mb-4 block">BLOG</span>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Son Makaleler
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {articlesData.slice(0, 3).map((article) => (
              <Link
                key={article.id}
                to={`/makale/${article.id}`}
                className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="inline-block px-3 py-1 bg-white/90 backdrop-blur-sm rounded-full text-xs font-medium text-gray-700">
                      {article.category}
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <div className="flex items-center text-xs text-gray-500 mb-3 space-x-4">
                    <span className="flex items-center">
                      <i className="ri-calendar-line mr-1"></i>
                      {article.date}
                    </span>
                    <span className="flex items-center">
                      <i className="ri-time-line mr-1"></i>
                      {article.readTime}
                    </span>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-3 group-hover:text-orange-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed line-clamp-2">
                    {article.excerpt}
                  </p>
                  <div className="mt-4 flex items-center text-orange-600 font-medium text-sm">
                    Devamını Oku
                    <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform"></i>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link
              to="/makaleler"
              className="inline-flex items-center px-8 py-3.5 bg-gray-900 text-white font-medium rounded-full hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              Tüm Makaleleri Gör
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </section>

      <section className="py-20 px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=young%20child%20sitting%20alone%20staring%20at%20tablet%20screen%20in%20dimly%20lit%20room%20concerned%20parent%20watching%20from%20doorway%20digital%20device%20addiction%20concept%20screen%20time%20management%20family%20concern%20about%20technology%20overuse%20modern%20parenting%20challenges%20soft%20dramatic%20lighting%20showing%20isolation%20and%20disconnection%20from%20real%20world%20activities&width=900&height=700&seq=screenaddiction1&orientation=landscape"
                alt="Ekran Bağımlılığı"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div>
              <span className="text-sm text-orange-600 font-semibold mb-4 block">DİJİTAL ÇAĞIN SORUNU</span>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Ekran Bağımlılığı ve Dijital Denge
              </h2>
              <p className="text-gray-600 mb-8 leading-relaxed">
                Günümüzde çocuklar ve ergenler dijital cihazlarla çok erken yaşta tanışıyor. Ekran bağımlılığı, sosyal gelişimi, akademik başarıyı ve duygusal sağlığı olumsuz etkileyebilir. Çocuğunuzun dijital dünya ile sağlıklı bir ilişki kurmasına yardımcı oluyoruz.
              </p>
              <ul className="space-y-4 mb-8">
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700">Aşırı ekran kullanımı ve oyun bağımlılığı</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700">Sosyal medya kullanımı ve özgüven sorunları</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700">Dijital denge ve sağlıklı sınırlar oluşturma</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700">Ebeveynler için dijital ebeveynlik stratejileri</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700">Alternatif aktiviteler ve gerçek dünya bağlantıları</span>
                </li>
              </ul>
              <Link
                to="/ekran-bagimliligi"
                className="inline-flex items-center px-8 py-3.5 bg-orange-500 text-white font-medium rounded-full hover:bg-orange-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                Detaylı Bilgi
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
